import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useCreateImageResourceMutation = createMutationHook(
  MembershipsCreatorApiClient.createImageResource,
  {
    mutationKey: ['createImageResource'],
  },
)
